import { type ForwardedRef, forwardRef } from 'react';

export const BaseLineHelp = forwardRef(
  (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>, ref: ForwardedRef<SVGSVGElement>) => (
    <svg
      width="1em"
      height="1em"
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <path
        d="M12 22C14.7614 22 17.2614 20.8807 19.0711 19.0711C20.8807 17.2614 22 14.7614 22 12C22 9.2386 20.8807 6.7386 19.0711 4.92893C17.2614 3.11929 14.7614 2 12 2C9.2386 2 6.7386 3.11929 4.92893 4.92893C3.11929 6.7386 2 9.2386 2 12C2 14.7614 3.11929 17.2614 4.92893 19.0711C6.7386 20.8807 9.2386 22 12 22Z"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M12.0008 14.0813V14.0813C12.0008 13.0872 12.8895 12.3186 13.6704 11.7034C14.2979 11.209 14.7008 10.4422 14.7008 9.58135C14.7008 8.09018 13.4919 6.88135 12.0008 6.88135C10.5096 6.88135 9.30078 8.09018 9.30078 9.58135"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M12 18.1313C12.6213 18.1313 13.125 17.6277 13.125 17.0063C13.125 16.385 12.6213 15.8813 12 15.8813C11.3787 15.8813 10.875 16.385 10.875 17.0063C10.875 17.6277 11.3787 18.1313 12 18.1313Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  ),
);
